/** Formats a number with exactly two decimals and US digit grouping. */
const numberFormatter = Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

export default numberFormatter;
